import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=3cc9c2c4&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9c2c4",
  null
  
)

export default component.exports